import React, { useState, useEffect, useContext } from "react"
import { Row, Col} from "reactstrap"
import "./datatables.scss"
import "../../assets/scss/manual/manual.scss"
import { AuthContext } from "context/authContext"
import { useLocation } from "react-router-dom";
import toast from 'react-hot-toast';
import axios from "axios";
import AppConfig from "../../constants/config";
import MUIDataTable from "mui-datatables";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { getMuiTheme } from 'helpers/mui_theme'

const GLAccount = (prop) => {
  const {setactiveTab} = prop;
  const location = useLocation();
  const { mode } = useContext(AuthContext)
  const [glData, setGlData] = useState([]);
  const [id, setId] = useState('')
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState({})
  const [updateRow, setUpdateRow] = useState(false)
  const [deleteRow, setDeleteRow] = useState(false)
  const [index, setIndex] = useState(false)
  const [firstOpen, setFirstOpen] = useState(false)

  const [addRow, setAddRow] = useState(false)
  const columns = [
    {
      name: "jecolumn",
      label: "Financial statement line item",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({style: {minWidth: '200px',height: '70px'}}),
        setCellHeaderProps: () => ({style: {minWidth: '200px',height: '50px'}}),
        customBodyRenderLite:(dataIndex,rowIndex)=>(
          <div style={{fontSize:'13px',display:'flex', justifyContent:'between'}}>
            <div style={{ marginTop:'5px'}}>
              {glData && glData[dataIndex] && glData[dataIndex].jecolumn}
            </div>
            <div style={{display:'flex'}}>
              { 
                glData && glData[dataIndex] && glData[dataIndex].inputValue && 
                <>
                  <button type="button" style={{ backgroundColor: 'transparent', borderColor: 'transparent', padding:'2px'}}
                    onClick={()=>{ setIndex(rowIndex);setDeleteRow(true)}}
                    > 
                    <i className="fas fa-minus-circle" style={{fontSize: '22px',color: "#CC0000" }}></i>
                  </button>
                </>
              }
              <button
              type="button" style={{ backgroundColor: 'transparent', borderColor: 'transparent', padding:'2px 2px 2px 0px'}}
              onClick={()=>{ setIndex(rowIndex);setAddRow(true)}}
              > 
              <i className="fas fa-plus-circle" style={{fontSize: '22px',color: "#38761D" }}></i>
              </button>
            </div>
          </div>
        )
      },
    },
    {
      label: "Account Number",
      name: "ac_number",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({style: {minWidth: '100px'}}),
        setCellHeaderProps: () => ({style: {minWidth: '100px'}}),
        customBodyRenderLite:(dataIndex,rowIndex)=>{
          return <Editable value={glData && glData[dataIndex] && glData[dataIndex].ac_number} rowIndex={dataIndex} setRowData={setRowData} setUpdateRow={setUpdateRow} column={'ac_number'} key={`${dataIndex}-ac_number`}/>
        },
      },
    },
    {
      label: "G/L Account Description",
      name: "glaccount_description",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite:(dataIndex,rowIndex)=>{ 
          return <Editable value={glData && glData[dataIndex] && glData[dataIndex].glaccount_description} rowIndex={dataIndex} setRowData={setRowData} setUpdateRow={setUpdateRow} column={'glaccount_description'} key={`${dataIndex}-glaccount_description`}/>
        }
      }
    },
    {
      label: "G/L Type",
      name: "gl_type",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite:(dataIndex,rowIndex)=>{
          return <Editable value={glData && glData[dataIndex] && glData[dataIndex].gl_type} rowIndex={dataIndex} setRowData={setRowData} setUpdateRow={setUpdateRow} column={'gl_type'} key={`${dataIndex}-gl_type`}/>
        },
      }
    },
  ];

  useEffect(()=>{
    if(addRow){
      let updatedData = [...glData]
      let data = {...updatedData[index]}
      data.inputValue = true
      delete data._id
      updatedData.splice((index + 1),0, data)
      setGlData(updatedData)
      setAddRow(false)
    }
  },[addRow])

  useEffect(()=>{
    if(deleteRow){
      const updatedData = [...glData]
      updatedData.splice(index,1)
      setGlData(updatedData)
      setDeleteRow(false)
    }
  },[deleteRow])

  useEffect(() => {
    setId((location.search).replace('?', ''));
  }, [])

  useEffect(() => {
    if(id){
      getGlAccounts()
    }
  },[id])

  const getGlAccounts = async()=>{
    setLoading(true)
    try {
        const {data} = await axios.get(`${AppConfig.baseUrl}/gl_account/list_gl_account?id=${id}`,{
            headers: { token: localStorage.getItem("token") }
        });
        if(!data.error){
          if(data.accountData && data.accountData.length > 0){
            setFirstOpen(false)
            const index = data.accountData.findLastIndex(v=>v.jecolumn == 'Lease liability' || v.jecolumn == 'Lease Liability' || v.jecolumn == 'Receivable')
            const stIndex = data.accountData.findLastIndex(v=>v.jecolumn == 'Lease Asset-Liability')
            if(stIndex < 0)data.accountData.splice(index+1, 0, { jecolumn:"Lease Asset-Liability", preview:"-Lease Asset-Liability",ac_number: '',glaccount_description : "Lease Asset-Liability",gl_type:'Liability',client_id:id});
            setGlData(data.accountData)
          }else{
            setFirstOpen(true)
            let values = mode == 'lessor' ? 
            [{ jecolumn:'Receipt Suspense Account Before Commencement', preview:'-Receipt Suspense Account Before Commencement',ac_number: '',glaccount_description : 'Receipt Suspense Account Before Commencement',gl_type:'Asset',client_id:id},{ jecolumn:'Rent Deposit', preview:'-Rent Deposit',ac_number: '',glaccount_description : 'Rent Deposit',gl_type:'Liability',client_id:id},{ jecolumn:'Rent Receipt Suspense Account', preview:'-Rent Receipt Suspense Account',ac_number: '',glaccount_description :'Rent Receipt Suspense Account',gl_type:'Asset',client_id:id},{ jecolumn:'Deferred inflow of resources', preview:'-Deferred inflow of resources',ac_number: '',glaccount_description : 'Deferred inflow of resources' ,gl_type:'Asset',client_id:id},{ jecolumn:"Receivable", preview:"-Receivable",ac_number: '',glaccount_description : "Receivable" ,gl_type:'Liability',client_id:id},{ jecolumn:"Lease Asset-Liability", preview:"-Lease Asset-Liability",ac_number: '',glaccount_description : "Lease Asset-Liability",gl_type:'Liability',client_id:id},{ jecolumn:'Interest Income', preview:'-Interest Income',ac_number: '',glaccount_description : 'Interest Income',gl_type:'Expense',client_id:id},{ jecolumn:'Lease Revenue', preview:'-Lease Revenue' ,ac_number: '',glaccount_description : 'Lease Revenue' ,gl_type:'Expense',client_id:id},{ jecolumn:'Financing Variable Lease Revenue', preview:'-Financing Variable Lease Revenue' ,ac_number: '',glaccount_description : 'Financing Variable Lease Revenue' ,gl_type:'Expense',client_id:id},{ jecolumn:'Modification Loss or Gain', preview:'-Modification Loss or Gain',ac_number: '',glaccount_description : 'Modification Loss or Gain',gl_type:'Expense',client_id:id},{ jecolumn:'Transition', preview:'-Transition',ac_number: '',glaccount_description : 'Transition',gl_type:'Liability',client_id:id},{ jecolumn:'Miscellaneous', preview:'-Miscellaneous',ac_number: '',glaccount_description : 'Miscellaneous',gl_type:'NA',client_id:id}] :
            [{ jecolumn:'Payment Suspense Account Before Commencement', preview:'-Payment Suspense Account Before Commencement',ac_number: '',glaccount_description : 'Payment Suspense Account Before Commencement',gl_type:'Asset',client_id:id},{ jecolumn:'Rent Deposit', preview:'-Rent Deposit',ac_number: '',glaccount_description : 'Rent Deposit',gl_type:'Asset',client_id:id},{ jecolumn:'Rent Payment Suspense Account', preview:'-Rent Payment Suspense Account',ac_number: '',glaccount_description :'Rent Payment Suspense Account',gl_type:'Asset',client_id:id},{ jecolumn:'ROU Asset', preview:'-ROU Asset',ac_number: '',glaccount_description : 'ROU Asset',gl_type:'Asset',client_id:id},{ jecolumn:"Lease liability", preview:"-Lease liability",ac_number: '',glaccount_description : "Lease liability",gl_type:'Liability',client_id:id},{ jecolumn:"Lease Asset-Liability", preview:"-Lease Asset-Liability",ac_number: '',glaccount_description : "Lease Asset-Liability",gl_type:'Liability',client_id:id},{ jecolumn:'Rent Expense', preview:'-Rent Expense',ac_number: '',glaccount_description : 'Rent Expense',gl_type:'Expense',client_id:id},{ jecolumn:'Interest Expense', preview:'-Interest Expense',ac_number: '',glaccount_description : 'Interest Expense',gl_type:'Expense',client_id:id},{ jecolumn:'Amortization', preview:'-Amortization',ac_number: '',glaccount_description : 'Amortization',gl_type:'Expense',client_id:id},{ jecolumn:'Operating Variable Lease Expense', preview:'-Operating Variable Lease Expense',ac_number: '',glaccount_description : 'Operating Variable Lease Expense',gl_type:'Expense',client_id:id},{ jecolumn:'Financing Variable Lease Expense', preview:'-Financing Variable Lease Expense',ac_number: '',glaccount_description :'Financing Variable Lease Expense',gl_type:'Expense',client_id:id},{ jecolumn:'Modification Loss or Gain', preview:'-Modification Loss or Gain',ac_number: '',glaccount_description : 'Modification Loss or Gain',gl_type:'Expense',client_id:id},{ jecolumn:'Impairment', preview:'-Impairment',ac_number: '',glaccount_description : 'Impairment',gl_type:'Expense',client_id:id},{ jecolumn:'Transition', preview:'-Transition',ac_number: '',glaccount_description : 'Transition',gl_type:'Liability',client_id:id},{ jecolumn:'Miscellaneous', preview:'-Miscellaneous',ac_number: '',glaccount_description : 'Miscellaneous',gl_type:'NA',client_id:id}]
            setGlData(values)
          }
        }
        else{
            throw new Error(data.title);
        }
    } catch (error) {
        toast.error(error.message || 'Something went wrong');
    }
    setLoading(false)
  }

  const saveGlAccount = async(buttontype) => {
    setLoading(true)
    try {
        let values = {id,glData}
        const {data} = await axios.post(`${AppConfig.baseUrl}/gl_account/add_gl_account`,values,{
            headers: { token: localStorage.getItem("token") }
        });
        if(!data.error){
            setFirstOpen(false)
            toast.success(data.message || 'G/L Account added successfully');
            if(buttontype){ 
              setactiveTab(2)
            }
        }
        else{
            throw new Error(data.title);
        }
    } catch (error) {
        toast.error(error.message || 'Something went wrong');
    }
    setLoading(false)
  }

  useEffect(()=>{
    if(updateRow){
      const updatedData = [...glData]
      updatedData[rowData.rowIndex][rowData.column] = rowData.inputValue
      updatedData[rowData.rowIndex].preview = `${updatedData[rowData.rowIndex].ac_number}-${updatedData[rowData.rowIndex].glaccount_description}`
      setGlData(updatedData)
      setUpdateRow(false)
    }
  },[updateRow])

  const rowStyle = (row, rowIndex) => {
    return { backgroundColor: row.jecolumn == "Rent Deposit" || row.jecolumn == "Rou Asset" || row.jecolumn == "Rent Expense" || row.jecolumn == "Amortization" || row.jecolumn == "Financing variable Lease Expense" || row.jecolumn == "Impairment" || row.jecolumn == "Miscellaneous"? '#f8f9fa' : '#fff' };
  };

  return (
    <React.Fragment>
          <Row>
            <Col className="col-12">
              <ThemeProvider theme={createTheme({components: getMuiTheme()})}>
                <MUIDataTable
                  title=""
                  data={glData}
                  columns={columns}
                  options={{ 
                    rowsPerPage:1000, 
                    print:false, 
                    download:false, 
                    filter:false, 
                    viewColumns: false,
                    selectableRows:"none", 
                    search:false, 
                    pagination:false,
                    rowsPerPageOptions:[], 
                    responsive:'scroll',
                    textLabels: {
                      viewColumns: {
                        title: "",
                      },
                    } 
                  }}
                />
              </ThemeProvider>
              <Row className="row mb-2 mt-3">
                <Col md='8'></Col>
                <Col md='4' style={{ textAlign: 'end' }}>
                    <button
                        type="button"
                        className="btn btn-lbusers me-2"
                        onClick={()=>saveGlAccount('')}
                        disabled={loading}
                    >
                        SAVE
                    </button>
                    <button
                        type="button"
                        className="btn btn-lbusers me-2"
                        onClick={()=>{saveGlAccount('next')}}
                        disabled={loading}
                    >
                        SAVE AND PROCEED
                    </button>
                    { !firstOpen &&
                      <button
                          type="button"
                          className="btn btn-lbusers"
                          onClick={()=>{setactiveTab(2)}}
                          disabled={loading}
                      >
                          NEXT
                      </button>
                    }
                </Col>
              </Row>
            </Col>
          </Row>
    </React.Fragment>
  )
}

const Editable = (prop) => {
  const {value, rowIndex, column, setRowData, setUpdateRow } = prop;
  const [inputValue, setInputValue] = useState(value);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleBlur = () => {
    setRowData({rowIndex, column, inputValue})
    setUpdateRow(true)
  };

  useEffect(()=>{
    setInputValue(value)
  },[value])

  return (
    <>
      {
        column == 'gl_type' ? 
        <select className="form-control" name="gl_type" id="gl_type" onChange={handleInputChange} value={inputValue} onBlur={handleBlur}>
          <option value="Asset">Asset</option>
          <option value="Liability">Liability</option>
          <option value="Expense">Expense</option>
          <option value="Revenue">Revenue</option>
          <option value="NA">NA</option>
        </select>
        :
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleBlur}
          className={`form-control`} 
        />
      }
    </>
  );
}

export default GLAccount
